export const analyticsPageLoad = pageName => {
  try {
    // instantiate a CustomEvent with an eventType of “pageLoad”
    const event = new CustomEvent('pageLoad', {
      detail: {
        // set the value of the function’s page parameter to
        // a “page” property on the CustomEvent’s detail object
        page: pageName
      }
    });
    // dispatch the CustomEvent from the body
    document.body.dispatchEvent(event);
  } catch(e) {
    //eslint-disable-no-empty
  }
};